import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Whychoosespeeech() {
  return (
    <section className="voice_services why_choose_speech p-100 overflow-x-hidden">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={9}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Why Choose Tekrevol For <span>Vendor Portal</span> Development?
            </h2>
            <p>
              At TekRevol, we create modern, highly secure vendor portals to
              solve the most complicated business problems. Our services assist
              you in advancing your company processes, improving security, and
              optimizing your work by utilizing cutting-edge technologies
              tailored to your specific activities.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Complex System Integration</h5>
                    <p>
                      We specialize in accurately implementing and syncing
                      vendor portals with a variety of systems and third-party
                      applications.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Flexible Development</h5>
                    <p>
                      We have a very flexible approach to producing our goods so
                      that they may match your needs and accommodate any
                      adjustments that may emerge along the route.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Scalability Limitations</h5>
                    <p>
                      Our portals are designed with expansion in mind; we check
                      and test for any indications of scalability constraints
                      that could lead to system degradation as your company
                      grows.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Efficient Migration</h5>
                    <p>
                      To provide a seamless migration process, we migrate vendor
                      portals in the most effective and timely manner to the
                      next platform or newest versions with minimal disruption.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Inefficient business processes</h5>
                    <p>
                      Our vendor portals reduce and remove unproductive business
                      tasks, improving organizational effectiveness and
                      efficiency through process automation and improvement.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Custom Solutions</h5>
                    <p>
                      We create vendor portals that are tailored to your
                      strategic goals, providing you with customized web apps
                      that answer your business concerns and needs.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
